/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import EndDate from './EndDate/index'
import ProgressBar from './ProgressBar/index'
import ProgressInMonths from './ProgressInMonths/index'
import React from 'react'
import StartDate from './StartDate/index'
import WeeksCompleted from './WeeksCompleted/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/Progress/Content/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<ProgressInMonths
  viewPath={`${viewPath}/ProgressInMonths`}
/>
<WeeksCompleted
  viewPath={`${viewPath}/WeeksCompleted`}
/>
</div>
<ProgressBar
  viewPath={`${viewPath}/ProgressBar`}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<StartDate
  viewPath={`${viewPath}/StartDate`}
/>
<EndDate
  viewPath={`${viewPath}/EndDate`}
/>
</div>
</div>
{children}
</React.Fragment>)
}